import { Link } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';

export default function Success() {
  return (
    <AuthLayout>
      <div className="text-center">
        {/* Success Icon */}
          <div className="mx-auto h-16 w-16 bg-green-100 rounded-full flex items-center justify-center">
            <svg
              className="h-10 w-10 text-green-600"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          <h2 className="mt-6 text-3xl font-bold text-gray-900">
            Successfully Authenticated!
          </h2>
          <p className="mt-2 text-gray-600">
            You have been successfully logged in to the IAM service.
          </p>

          <div className="mt-8">
            <Link to="/login" className="btn-primary block text-center">
              Back to Login
            </Link>
          </div>

        <p className="mt-4 text-sm text-gray-500">
          This is a demo success page. In production, you would be redirected to your application.
        </p>
      </div>
    </AuthLayout>
  );
}

